<template lang="">
  <div>
    <Header
      title="Teste AB"
      subtitle="Gerador de Links para teste AB"
    ></Header>

    <template>
      <v-tabs
        v-model="tab"
        centered
        color='black'
        class="d-flex justify-start"
      >
        <v-tab href="#generator" name="generator" class="mb-2">
          <img src="../../../../static/images/generator-url.svg"/>
          <span class="pl-3" style="text-transform: capitalize">Gerdador de Url</span>
        </v-tab>
        <v-tab href="#logs" name="logs" class="mb-2">
          <img src="../../../../static/images/search-black.svg" color="red"/>
          <span class="pl-3" style="text-transform: capitalize">Logs</span>
        </v-tab>
        <v-tab href="#antigos" name="antigos" class="mb-2">
          <img src="../../../../static/images/search-black.svg" color="red"/>
          <span class="pl-3" style="text-transform: capitalize">Logs(Antigos)</span>
        </v-tab>
      </v-tabs>
    </template>
    <hr>
    
    <div v-if="tab === 'generator'">
      <GeneratorUrl />
    </div>
    <div v-if="tab === 'logs'">
      <LogsSplitTest />
    </div> 
    <div v-if="tab === 'antigos'">
      <OldLogsSplitTest />
    </div> 
  </div>
</template>
<script>
// Components
import Header from '@/components/Header.vue'
import GeneratorUrl from '@/components/Contents/SplitTest/GeneratorUrl.vue'
import LogsSplitTest from '@/components/Contents/SplitTest/LogsSplitTest.vue'
import OldLogsSplitTest from '@/components/Contents/SplitTest/OldLogsSplitTest.vue'

export default {
  components: {
    Header,
    GeneratorUrl,
    LogsSplitTest,
    OldLogsSplitTest
  },
  data () {
    return {
      tab: 'generator',
    }
  }
}
</script>
<style lang="">
  .ff {
    text-transform: capitalize;
  }
  /* .mx-input-wrapper {
    width: 276px;
  } */

  @media screen and (max-width: 1377px) {
  .mx-input-wrapper {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/SplitTest/SplitTest.vue